<template>
  <div>
    <Layout/>
    <h4>Planes</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idPlan" class="form-label">IdPlan</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPlan" name="idPlan" v-model="datoPlan.idPlan" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoPlan.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripción</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="descripcion" name="descripcion" v-model="datoPlan.descripcion" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="precio" class="form-label">Precio</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="precio" name="precio" v-model="datoPlan.precio" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoPlan.fechaReg" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarPlan" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarPlan" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPlan" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdSuscripcion</th>
          <th scope="col">IdPlan</th>
          <th scope="col">IdUsuario</th>
          <th scope="col">IdFormaPago</th>
          <th scope="col">Número</th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaDesde</th>
          <th scope="col">FechaHasta</th>
          <th scope="col">Estado</th>
          <th scope="col">FormaPagoNombre</th>
          <th scope="col">UsuarioNombre</th>
          <th scope="col">PlanNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="suscripcion in datosPaginados" :key="suscripcion.idSuscripcion">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(suscripcion.idSuscripcion)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(suscripcion.idSuscripcion)" title="Editar">edit_square</i></td>
          <td>{{suscripcion.idSuscripcion}}</td>
          <td>{{suscripcion.idPlan}}</td>
          <td>{{suscripcion.idUsuario}}</td>
          <td>{{suscripcion.idFormaPago}}</td>
          <td>{{suscripcion.numero}}</td>
          <td>{{getFormattedDate(suscripcion.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(suscripcion.fechaDesde, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(suscripcion.fechaHasta, 'DD/MM/YYYY')}}</td>
          <td>{{suscripcion.estado}}</td>
          <td>{{suscripcion.formaPagoNombre}}</td>
          <td>{{suscripcion.usuarioNombre}}</td>
          <td>{{suscripcion.planNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deletePlan(suscripcion.idSuscripcion)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idSuscripcion" class="form-label">IdSuscripcion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idSuscripcion" name="idSuscripcion" v-model="datoSuscripcion.idSuscripcion" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idPlan" class="form-label">IdPlan</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPlan" name="idPlan" v-model="datoSuscripcion.idPlan" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuario" class="form-label">IdUsuario</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuario" name="idUsuario" v-model="datoSuscripcion.idUsuario" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idFormaPago" name="idFormaPago" v-model="datoSuscripcion.idFormaPago"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idFormaPago" class="form-label"> Forma Pago</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="formaPago" name="formaPago" v-model="datoSuscripcion.formaPago" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalFormaPagoLOV"
                      title="Buscar Suscripción: Forma de Pago">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="numero" class="form-label">Numero</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="numero" name="numero" v-model="datoSuscripcion.numero" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoSuscripcion.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaDesde" class="form-label">FechaDesde</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaDesde" name="fechaDesde" v-model="datoSuscripcion.fechaDesde" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaHasta" class="form-label">FechaHasta</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaHasta" name="fechaHasta" v-model="datoSuscripcion.fechaHasta" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarSuscripcion" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditSuscripcion" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: Suscripcion -->
    <SuscripcionLOVdet @DatosSuscripcion="GetDataSuscripcionLOVdet($event)"/>
<!-- Lista de Valores: FormaPago -->
    <FormaPagoLOVdet @DatosFormaPago="GetDataFormaPagoLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';
// Listas de valores master
// Listas de valores master
// Listas de valores details
import SuscripcionLOVdet from '../../components/lovs/SuscripcionLOV.vue'
import FormaPagoLOVdet from '../../components/lovs/FormaPagoLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
// Listas de valores master
// Listas de valores details
, SuscripcionLOVdet
, FormaPagoLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      plans : [],
      datoPlan : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idPlan: '',
// Variables master
// Variables details
      suscripcions : [],
      datoSuscripcion : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idPlan = this.$route.params.p_idplan
    this.abrirEditar(this.p_idPlan)
    this.getSuscripcions()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      if(this.datoPlan.idPlan === ''){
        swal("Error!", "El elemento idPlan no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlan.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlan.descripcion === ''){
        swal("Error!", "El elemento descripcion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlan.precio === ''){
        swal("Error!", "El elemento precio no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlan.fechaReg === ''){
        swal("Error!", "El elemento fechaReg no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPlan.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarPlan(){
      if(this.validarForm() === 1){
        try {
          await api.post('/plans', this.datoPlan)
          swal("Correcto!", "Plan creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPlan(){
      if(this.validarForm() === 1){
        try {
          await api.post('/plans', this.datoPlan)
          swal("Correcto!", "Plan creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoPlan={}
      this.titulo   = 'Crear Planes'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idPlan){
      this.modalWindow = true
      if(idPlan != null){    
           api.get('/vwplans/'+idPlan).then(resp=>{
          this.datoPlan = resp.data;
           });
      }
      this.titulo   = 'Editar Planes'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarPlan(){
      this.$router.push('/Plan')
    },
// Procedimientos master
// Procedimientos detalle
    async getSuscripcions() {
      const resp = await api.get('/suscripcions')
      this.suscripcions = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.suscripcions.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwsuscripcions/nombre/'+this.nombreBusqueda).then(response=>{
          this.suscripcions=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.suscripcions.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwsuscripcions').then(response=>{
      this.suscripcions=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.suscripcions.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoSuscripcion.idPlan === ''){
        swal("Error!", "El elemento idPlan no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoSuscripcion.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoSuscripcion.descripcion === ''){
        swal("Error!", "El elemento descripcion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoSuscripcion.precio === ''){
        swal("Error!", "El elemento precio no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoSuscripcion.fechaReg === ''){
        swal("Error!", "El elemento fechaReg no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoSuscripcion.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarSuscripcion(){
      if(this.validarForm() === 1){
        try {
          this.datoSuscripcion.idPlan = this.datoPlan.idPlan;
          await api.post('/suscripcions', this.datoSuscripcion)
          this.getSuscripcions();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Suscripcion creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditSuscripcion(){
      if(this.validarForm() === 1){
        try {
          await api.post('/suscripcions', this.datoSuscripcion)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Suscripcion creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoSuscripcion={}
      this.titulo   = 'Crear Planes'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idSuscripcion){
      this.modalWindow = true
      if(idSuscripcion != null){    
           api.get('/vwsuscripcions/'+idSuscripcion).then(resp=>{
          this.datoSuscripcion = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Planes'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idSuscripcion){
      this.modalWindow = true
      if(idSuscripcion != null){
        this.$router.push('/suscripcionmd/'+idSuscripcion)
      }
    },
    async deleteSuscripcion (idSuscripcion) {
      try{
        await api.delete('/suscripcions/'+idSuscripcion)
          this.getSuscripcions()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataSuscripcionLOVdet(data) {
      this.datoSuscripcion.idSuscripcion = data.idSuscripcion;
      this.datoSuscripcion.suscripcion = data.nombre;
    },
//    Lista de Valores
    GetDataFormaPagoLOVdet(data) {
      this.datoSuscripcion.idFormaPago = data.idFormaPago;
      this.datoSuscripcion.formaPago = data.nombre;
    },
// Listas de valores details
  },
}
</script>
